customElements.get("vanilla-slider") || customElements.define("vanilla-slider", class extends HTMLElement {
  constructor() {
    super(), this.slider = this.querySelector(":scope [data-slider]"), this.autoplayIndex = 0, 
    this.interval, this.showArrow = this.showArrow.bind(this), this.hideArrow = this.hideArrow.bind(this), 
    this.update = this.update.bind(this), this.scroll = this.scroll.bind(this), this.goTo = this.goTo.bind(this);
  }
  connectedCallback() {
    if (!this.slider) return !1;
    this.slides = this.getSlides(), this.prev = this.querySelectorAll(":scope [data-prev]"), 
    this.next = this.querySelectorAll(":scope [data-next]"), this.nav = this.querySelectorAll(":scope [data-nav]"), 
    this.animate = this.hasAttribute("data-animate"), this.autoplay = Number(1e3 * this.dataset.autoplay || 0), 
    this.autoplay && (this.autoplay, parseInt(getComputedStyle(document.documentElement).getPropertyValue("--duration"))), 
    this.addEventListeners(), this.update(), this.autoplay && (this.interval = setInterval((() => {
      this.autoplayIndex = this.autoplayIndex + 1 > this.slides.length - 1 ? 0 : this.autoplayIndex + 1, 
      this.goTo(this.autoplayIndex);
    }), this.autoplay));
  }
  getSlides() {
    return this.querySelectorAll(":scope [data-slider] > [data-slide]");
  }
  getSlideWidth() {
    return ([ ...this.slides ].find((t => t.offsetWidth > 0))?.offsetWidth || this.slider.width) + (parseInt(getComputedStyle(this.slider).getPropertyValue("gap").split(" ")[0]) || 0);
  }
  scroll(t, e = !1) {
    e && (e.preventDefault(), e.stopPropagation()), "left" === t ? this.slider.scrollBy({
      left: -1 * this.getSlideWidth(),
      behavior: "smooth"
    }) : this.slider.scrollBy({
      left: this.getSlideWidth(),
      behavior: "smooth"
    });
  }
  goTo(t, e = "smooth", s = !1) {
    s && (s.preventDefault(), s.stopPropagation()), this.slider.scrollTo({
      left: this.getSlideWidth() * parseInt(t),
      behavior: e
    });
  }
  hideArrow(t) {
    t.disabled = !0, t.ariaDisabled = !0;
  }
  showArrow(t) {
    t.disabled = !1, t.ariaDisabled = !1;
  }
  updateArrows() {
    const t = this.slider.scrollLeft > 0;
    this.prev.forEach((e => {
      t ? this.showArrow(e) : this.hideArrow(e);
    }));
    const e = this.slider.scrollLeft + this.slider.offsetWidth < this.slider.scrollWidth - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--spacing-offset"));
    this.next.forEach((t => {
      e ? this.showArrow(t) : this.hideArrow(t);
    }));
  }
  updateNav() {
    const t = this.getIndex();
    this.nav.forEach((e => {
      e.querySelectorAll("button").forEach(((e, s) => {
        if (e.ariaCurrent = s === t ? "true" : "false", this.animate) {
          const i = e.querySelector("span");
          if (!i) return;
          i.classList.remove("w-full", "duration-[var(--delay)]", "transition-all"), s === t ? i.classList.add("w-full", "duration-[var(--delay)]", "transition-all") : i.classList.add("w-0");
        }
      }));
    }));
  }
  getIndex() {
    const t = [ ...this.slides ].find((t => "true" === String(t.ariaCurrent))), e = [ ...this.slider.children ].indexOf(t);
    return Math.max(e, 0);
  }
  update() {
    this.updateArrows(), setTimeout((() => this.updateNav()), 300);
  }
  addEventListeners() {
    this.prev.forEach((t => t.addEventListener("click", (t => this.scroll("left", t))))), 
    this.next.forEach((t => t.addEventListener("click", (t => this.scroll("right", t))))), 
    this.nav.forEach((t => t.querySelectorAll("button").forEach(((t, e) => t.addEventListener("click", (t => this.goTo(e, "smooth", t)))))));
    const t = this.closest(".shopify-section");
    t && t.addEventListener("input", (() => this.goTo(0, "instant"))), this.autoplay && [ "wheel", "touchmove", "click" ].forEach((t => {
      this.addEventListener(t, (() => {
        clearInterval(this.interval), this.style.setProperty("--delay", "var(--duration)");
      }), {
        passive: !0
      });
    })), this.intersectionObserver = new IntersectionObserver((t => {
      t.forEach((t => t.target.ariaCurrent = !!t.isIntersecting));
    }), {
      root: this.slider,
      threshold: .9
    }), this.slides.forEach((t => this.intersectionObserver.observe(t))), this.mutationObserver = new MutationObserver((() => {
      this.slides = this.getSlides(), this.slides.forEach((t => this.intersectionObserver.observe(t))), 
      this.update();
    })), this.mutationObserver.observe(this.slider, {
      childList: !0,
      subtree: !1
    });
    const e = () => this.update();
    [ "scroll", "scrollend" ].forEach((t => {
      this.slider.addEventListener(t, e, {
        passive: !0
      });
    })), this.slider.addEventListener("mouseenter", e, {
      passive: !0
    });
  }
});